module.exports = {"500115001":"凤城街道","500115002":"晏家街道","500115003":"江南街道","500115004":"渡舟街道","500115005":"新市街道","500115006":"八颗街道","500115007":"菩提街道","500115123":"邻封镇","500115124":"但渡镇","500115125":"云集镇","500115126":"长寿湖镇","500115127":"双龙镇","500115128":"龙河镇","500115129":"石堰镇","500115130":"云台镇","500115131":"海棠镇","500115132":"葛兰镇","500115136":"洪湖镇","500115137":"万顺镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/500115.json
// module id = 2355
// module chunks = 0